<template>
    <div>
        <div class="entries font-permanent_marker text-black">
            <h2 class="mb-8 text-48px text-co-dark-grey">Entries</h2>

            <div v-if="axios_errored">
                <h1>Sorry there are no resources available at this time. Please come back soon.</h1>
            </div>

            <div v-else-if="api_data.length">
                <carousel>
                    <div v-for="(data, $index) in api_data" :key="data.id">
                        <div :class="[$index % 2 !== 0 ? 'rotate-1' : '-rotate-2', 'mx-6 bg-entry-box transform']">
                            <a :href="`#entry-photo-modal-${data.id}`">
                                <img :src="data.featured_image_src"
                                    :alt="data.title.rendered"
                                    class="entry-preview-image">
                            </a>
                        </div>
                    </div>
                </carousel>

                <div v-for="data in api_data" :key="data.id">
                    <modal :name="`entry-photo-modal-${data.id}`">
                        <img :src="data.featured_image_src"
                            :alt="data.title.rendered">
                    </modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Carousel from './Carousel.vue'
import Modal from './Modal.vue'
import YoutubeEmbed from './YoutubeEmbed.vue'

export default {
    components: {
        Carousel,
        Modal,
        YoutubeEmbed,
    },

    props: {
        base_api_url: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            api_data: false,
            axios_errored: false
        }
    },
    
    beforeMount() {
        /**
         * Make request to Wordpress API to fetch competiiton entries.
         */
        axios.get(`${this.base_api_url}/wp-json/wp/v2/competition-entries?status=publish&order=asc`)
            .then(response => {
                this.api_data = response.data
            })
            .catch(error => {
                this.axios_errored = true
            })
    }
}
</script>
